import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './AuthField.css';
import eyeClose from './assets/eye_close.png';
import eyeOpen from './assets/eye_open.png';

function AuthField({
  id,
  name,
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  hasError,
  minLength,
  maxLength,
  showToggle = false,
  showPassword = false,
  onTogglePassword
}) {
  const inputType = showToggle ? (showPassword ? 'text' : 'password') : type;
  const inputClass = ['auth-input', showToggle ? 'auth-input-password' : '', hasError ? 'has-error' : ''].filter(Boolean).join(' ');

  return (
    <Row className="auth-field g-0">
      <Col xs={12} sm={12} md={12} lg={12}>
        <label className="auth-label" htmlFor={id}>
          {label}
        </label>
        <span className="auth-input-wrap">
          <input
            id={id}
            name={name}
            className={inputClass}
            placeholder={placeholder}
            type={inputType}
            value={value}
            onChange={onChange}
            minLength={minLength}
            maxLength={maxLength}
          />
          {showToggle && <img src={showPassword ? eyeOpen : eyeClose} className="auth-eye" alt="" onClick={onTogglePassword} />}
        </span>
      </Col>
    </Row>
  );
}

export default AuthField;
